import { render, staticRenderFns } from "./WelfareCentreOperationElderResidentsRate.vue?vue&type=template&id=b7fae32c&scoped=true&"
import script from "./WelfareCentreOperationElderResidentsRate.vue?vue&type=script&lang=js&"
export * from "./WelfareCentreOperationElderResidentsRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fae32c",
  null
  
)

export default component.exports